@if (!startDate && !endDate) {
  @if (withTimeFrameLabel) {
    <div class="w-h-label html-overflow">
      {{ timeFrameLabel | translate }}
    </div>
    <span>--</span>
  }
} @else {
  <div>
    @if (withTimeFrameLabel) {
      <div class="w-h-label html-overflow">
        {{ timeFrameLabel | translate }}
      </div>
    }
    <div class="flex--r-c gap--4">
      <div
        class="date-field"
        [ngClass]="{ 'date-conflict': displayConflict && startConflict }"
      >
        <span
          matTooltip="{{
            startDate
              ? isStartTimeVisible
                ? (startDate | date: 'short' : '' : currentLocale())
                : (startDate | date: 'shortDate' : '' : currentLocale())
              : '--'
          }}"
        >
          {{
            startDate
              ? isStartTimeVisible
                ? (startDate | date: "short" : "" : currentLocale())
                : (startDate | date: "shortDate" : "" : currentLocale())
              : "--"
          }}
        </span>
      </div>
      @if (!isSingleDate && endDate) {
        <mat-icon>arrow_right_alt</mat-icon>
      }
      @if (!isSingleDate) {
        <div class="date-field" [ngClass]="{ 'date-conflict': endConflict }">
          <span
            matTooltip="{{
              endDate
                ? isEndTimeVisible
                  ? (endDate | date: 'short' : '' : currentLocale())
                  : (endDate | date: 'shortDate' : '' : currentLocale())
                : '--'
            }}"
          >
            {{
              endDate
                ? isEndTimeVisible
                  ? (endDate | date: "short" : "" : currentLocale())
                  : (endDate | date: "shortDate" : "" : currentLocale())
                : "--"
            }}
          </span>
        </div>
      }
    </div>
  </div>
}
